<template lang="pug">
.navi
  //- .item(@click="goto('media')") Media
  .item(v-for="i in items", @click="goto(i.target)")
    icon.small(name="next")
    span {{ i.name }}
  //- .item Login
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  components: { Icon },
  data() {
    return {
      items: [
        { target: "tools", name: "Tools" },
        { target: "demos", name: "Demos" },
        { target: "about", name: "Über mich" },
        { target: "impressum", name: "Impressum" },
        { target: "contact", name: "Kontakt" },
      ],
    };
  },
  methods: {
    goto(target) {
      this.$router.push({ name: target }).catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import (reference) "../shared.less";
.navi {
  position: absolute;
  right: 2px;
  top: 2px;
  background: #fff;
  flex: 0 0 auto;
  display: flex;
  flex-flow: column nowrap;
  padding: 2rem 1rem;
  gap: 0.5rem;
  overflow: auto;
  justify-content: flex-end;
  align-items: flex-start;
  border: 1px solid gray;
  border-radius: 5px;
  box-shadow: -4px 4px 8px #777;
  z-index: 1;
}
// .naviContent {
//     flex: 0 0 auto;
//     display: flex;
//     align-items: center;
//     flex-flow: column nowrap;
//     overflow:auto;
// }
.item {
  font-size: 1.4rem;
  color: #69c;
  font-weight: bold;
  padding: 0.2rem 1rem;
  cursor: pointer;
  // font-size: 0.8rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

@media (orientation: landscape) {
  .navi {
    margin-top: -3rem;
    margin-bottom: 1rem;
  }
  .item {
    // font-size: 1.4vw;
    margin: 0 0.7vw;
  }
}

@media print {
  .navi {
    display: none !important;
  }
}
</style>
</style>